import axios from "axios"
import qs from "qs" //序列化
import store from '@/store'
import Vue from '@/main'
const service = axios.create({
  baseURL:process.env.baseURL,//api的baseurl
  // baseURL:'api',
  timeout:30000,//请求超时时间,
  responseType: "json",//返回数据格式
})

service.defaults.withCredentials = true;
//POST传参序列化(添加请求拦截器)
service.interceptors.request.use(config=> {

  // 打印环境
  // console.log(process.env)
      if(config.method ==='post' || config.method ==='put' || config.method ==='delete'){
        // config.data = qs.stringify( config.data)//序列化
      }
        // 若是有做鉴权token , 就给头部带上token
      if(localStorage.getItem("token")){
        var token = localStorage.getItem("token")
        config.headers.common['Authorization'] = token;
      }
      if(localStorage.getItem("sessionId")){
        var sessionId = localStorage.getItem("sessionId")
        config.headers.common['Access-Authorization'] = sessionId;
      }
      var locale = localStorage.getItem('locale') || 'zh';
          // console.log(locale)
   
      if(locale == 'en'){
        config.headers.common['Access-Lang'] = 'en_US';
      }else if(locale == 'zh'){
        config.headers.common['Access-Lang'] = 'zh_CN';
      }else{
        config.headers.common['Access-Lang'] = 'fr_FR';
      }
      
      
      
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
      return config
  },error => {
    // alert(error)
    return Promise.reject(error.data.error.message);
  }
);

service.interceptors.response.use(res=>{
  if(res.data){

  }
  return res;
},error=>{
        let tokenExpireOrIncorrect = JSON.parse(JSON.stringify(error)).message.indexOf('401')>-1
        if(tokenExpireOrIncorrect){
          localStorage.setItem('token','')  //将token 放入 
          localStorage.setItem('loginName','')
          // this.setLoginName("");
          store.dispatch('setLoginName', '')
          Vue.$message({
              message: Vue.$t("toLogin.token"),
              duration: 1000,
            });
          return false
        }
        // let text = JSON.parse(JSON.stringify(error)).response.status === 404
        //     ? '404'
        //     : '网络异常，请重试';
        //     alert(text)
        return Promise.reject(error)
})

export default service;